<template lang="pug">
  form(@submit.prevent="next")
    .text-large - Grau de infração
    .pt-2
      .form-group
        label.form-radio.mb--2(v-for='item in resource.modelo.params.osm.calculo.grau_de_infracoes')
          input(
            type='radio'
            v-model='resource.grau_de_infracao'
            name='grau_de_infracao'
            :checked='resource.grau_de_infracao === item.codigo'
            :value='item.codigo'
          )
          i.form-icon
          small {{ item.descricao }} - {{ item.valor | currency('R$ ') }}
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="!resource.grau_de_infracao")
        btn-content(name="next")
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [mixin],
}
</script>
